import React from 'react';

import { ProjectGeodataManager } from '../../viewer/project-geodata-manager';

const subscribe = (onChange: () => void) =>
  ProjectGeodataManager.instance().subscribeToActiveTimelineContainer(onChange);

/**
 * Returns the active timeline container, and re-renders when another one is activated. A timeline
 * switch keeps the scene, so scene changes don't tell when it happens.
 */
export const useActiveTimelineContainer = () =>
  React.useSyncExternalStore(subscribe, () =>
    ProjectGeodataManager.instance().getActiveTimelineContainer(),
  );
